import React from 'react';
import { Responsive } from '@cian/ui-kit';
import { LinkButton } from '@cian/ui-kit/button';
import classNames from 'classnames';

import { ShowPhone } from '../ShowPhone';
import { IJKInfo } from '../../types/results';

import * as styles from './styles.css';

interface ITabletCardControls {
  phone?: string | null;
  fullUrl: string;
  jkInfo?: IJKInfo | null;

  trackPhoneClick(): void;
  trackJKButtonClick(): void;
}

export const TabletCardControls: React.FC<ITabletCardControls> = ({
  phone,
  jkInfo,
  fullUrl,
  trackPhoneClick,
  trackJKButtonClick,
}) => {
  return (
    <>
      {phone && (
        <Responsive tablet>
          <div className={classNames(styles['show-phone'])}>
            <ShowPhone phones={[phone]} withNote trackClick={trackPhoneClick} />
          </div>
        </Responsive>
      )}
      {jkInfo && (
        <Responsive tablet>
          <div className={classNames(styles['show-phone'])}>
            <LinkButton size="XS" href={fullUrl} onClick={trackJKButtonClick}>
              Перейти к ЖК
            </LinkButton>
          </div>
        </Responsive>
      )}
    </>
  );
};
